export default __webpack_public_path__ + "static/media/Logo_EU_ATEMPO.048e8931.png";